 <script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * Form-element component
 */
export default {
  page: {
    title: "Anket Oluştur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Anket Oluştur",
      items: [
        {
          text: "Anket Oluştur",
          active: true,
        },
      ],
      FormJson: [ ],
    };
  },
  methods: {
    BolumAdd() {  
      this.FormJson.push({
      FormTitle:"Başlıksız Form "+(this.FormJson.length+1),
      FormFiled:[]});
    },
    BolumDel(Bolumindex) {  
       this.FormJson.splice(Bolumindex, 1);
    },
    SoruAdd(Bolumindex) {  
      this.FormJson[Bolumindex].FormFiled.push({
        type: "input",
        props: {
          ID: 4,
          title: "Soru",
          helpText: "",
        },
        config: {
          required: false,
          maxSelections: 10,
          placeHolder: null,
          type: "",
          rows: null,
          columns: null,
        },
        options: [],
      });
    },
    SoruDel(Bolumindex,index) { 
      this.FormJson[Bolumindex].FormFiled.splice(this.FormJson[Bolumindex].FormFiled.indexOf(index), 1);
    },

    OptinonsAdd(Bolumindex,index) { 
      this.FormJson[Bolumindex].FormFiled[index].options.push({
        value: "Seçenek",
        selected: false,
      });
    },
    OptinonsDel(Bolumindex,index, optionsindex) { 
      this.FormJson[Bolumindex].FormFiled[index].options.splice(
        this.FormJson[Bolumindex].FormFiled[index].options.indexOf(optionsindex),
        1
      );
    }, 
    submit() {
      const data = {
        FormJson: this.FormJson,
      };
      alert(JSON.stringify(data, null, 2));
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    {{ FormJson }}
    <div v-if="FormJson">
 <div v-for="(Bolumler, Bolumindex) in FormJson" :key="Bolumindex">
<div class="row" >
      <div class="col-12">
       
           <b-card bg-variant="primary" class="text-white-50">

<div class="row" >
      <div class="col-4">
<h5 class="mt-0 mb-1 text-white">
                <i class="mdi mdi-bullseye-arrow me-1"></i>
                {{ Bolumler.FormTitle }}</h5>
      </div>
      <div class="col-8">
<h5 class="mt-0 mb-1 text-white">   <div class="text-sm-end"> 
                Bölüm {{Bolumindex+1 }} / {{ FormJson.length }}
                 </div>
                
                </h5>
      </div>
</div>
<br>


<div class="row" >
      <div class="col-4">
<h5 class="mt-0 mb-1 text-white">
                <b-form-input
                  v-model="Bolumler.FormTitle"
                  type="text"
                ></b-form-input>
                </h5>
      </div>

            <div class="col-4">
<h5 class="mt-0 mb-1 text-white">
               </h5>
      </div>
      <div class="col-4">
<h5 class="mt-0 mb-1 text-white">
<div class="text-sm-end"> 
      <b-button
                        variant="danger"
                        @click="BolumDel(Bolumindex)"
                      >
                        <i
                          class="bx bx-trash font-size-16 align-middle me-2"
                        ></i>
                      </b-button>
                  </div>    
                </h5>
      </div>
</div>



              
                <div class="form-group col-md-1">
                  
                    </div>
            </b-card>   </div> </div>

    <div class="row"  v-for="(Form, index) in Bolumler.FormFiled" :key="index">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
             

              <div class="form-group col-md-6" v-if="Form.type == 'input'">
                <b-form-input
                  v-model="Form.props.title"
                  type="text"
                ></b-form-input>
                Kısa Yanıt Metni
              </div>

              <div class="form-group col-md-6" v-if="Form.type == 'textarea'">
                <b-form-input
                  v-model="Form.props.title"
                  type="text"
                ></b-form-input>
                Uzun Yanıt Metni
              </div>

              <div
                class="form-group col-md-6"
                v-if="Form.type == 'radiobutton'"
              >
                <div class="row">
                  <div class="form-group col-md-10">
                    <b-form-input
                      v-model="Form.props.title"
                      type="text"
                    ></b-form-input>
                  </div>
                  <br /><br /><br />
                  <div class="form-group col-md-1">
                    <b-button variant="success" @click="OptinonsAdd(Bolumindex,index)">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                    </b-button>
                  </div>
                  <div
                    class="row"
                    v-for="(options, optionsindex) in Form.options"
                    :key="optionsindex"
                  >
                    <div class="form-group col-md-1">
                      <i
                        class="
                          bx bx-radio-circle-marked
                          font-size-16
                          align-middle
                          me-2
                        "
                      ></i>
                    </div>
                    <div class="form-group col-md-10">
                      <b-form-input
                        v-model="options.value"
                        value="Seçenek"
                        type="text"
                      ></b-form-input>
                    </div>
                    <div class="form-group col-md-1">
                      <b-button
                        variant="danger"
                        @click="OptinonsDel(Bolumindex,index, optionsindex)"
                      >
                        <i
                          class="bx bx-trash font-size-16 align-middle me-2"
                        ></i>
                      </b-button>
                    </div>
                    <br /><br /><br />
                  </div>
                </div>
              </div>

              <div class="form-group col-md-6" v-if="Form.type == 'checkbox'">
                <div class="row">
                  <div class="form-group col-md-10">
                    <b-form-input
                      v-model="Form.props.title"
                      type="text"
                    ></b-form-input>
                  </div>
                  <br /><br /><br />
                  <div class="form-group col-md-1">
                    <b-button variant="success" @click="OptinonsAdd(Bolumindex,index)">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                    </b-button>
                  </div>
                  <div
                    class="row"
                    v-for="(options, optionsindex) in Form.options"
                    :key="optionsindex"
                  >
                    <div class="form-group col-md-1">
                      <i
                        class="
                          bx bx-check-square
                          font-size-16
                          align-middle
                          me-2
                        "
                      ></i>
                    </div>
                    <div class="form-group col-md-10">
                      <b-form-input
                        v-model="options.value"
                        value="Seçenek"
                        type="text"
                      ></b-form-input>
                    </div>
                    <div class="form-group col-md-1">
                      <b-button
                        variant="danger"
                        @click="OptinonsDel(Bolumindex,index, optionsindex)"
                      >
                        <i
                          class="bx bx-trash font-size-16 align-middle me-2"
                        ></i>
                      </b-button>
                    </div>
                    <br /><br /><br />
                  </div>
                </div>
              </div>

              <div class="form-group col-md-6" v-if="Form.type == 'combobox'">
                <div class="row">
                  <div class="form-group col-md-10">
                    <b-form-input
                      v-model="Form.props.title"
                      type="text"
                    ></b-form-input>
                  </div>
                  <br /><br /><br />
                  <div class="form-group col-md-1">
                    <b-button variant="success" @click="OptinonsAdd(Bolumindex,index)">
                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                    </b-button>
                  </div>
                  <div
                    class="row"
                    v-for="(options, optionsindex) in Form.options"
                    :key="optionsindex"
                  >
                    <div class="form-group col-md-1">
                      <i
                        class="bx bx bx-list-ol font-size-16 align-middle me-2"
                      ></i>
                    </div>
                    <div class="form-group col-md-10">
                      <b-form-input
                        v-model="options.value"
                        type="text"
                      ></b-form-input>
                    </div>
                    <div class="form-group col-md-1">
                      <b-button
                        variant="danger"
                        @click="OptinonsDel(Bolumindex,index, optionsindex)"
                      >
                        <i
                          class="bx bx-trash font-size-16 align-middle me-2"
                        ></i>
                      </b-button>
                    </div>
                    <br /><br /><br />
                  </div>
                </div>
              </div>

              <div class="form-group col-md-6" v-if="Form.type == 'date'">
                <b-form-input
                  v-model="Form.props.title"
                  type="text"
                ></b-form-input>
                Tarih
              </div>

              <div class="form-group col-md-6" v-if="Form.type == 'time'">
                <b-form-input
                  v-model="Form.props.title"
                  type="text"
                ></b-form-input>
                Saat
              </div>

              <div class="form-group col-md-6">
                <select
                  class="form-control"
                  v-model="Form.type"
                  @change="TipSecim(index)"
                >
                  <option value="input">Kısa Yanıt</option>
                  <option value="textarea">Paragraf</option>
                  <option value="radiobutton">Çoktan Seçmeli</option>
                  <option value="checkbox">Onay Kutuları</option>
                  <option value="combobox">Açılır Menü</option>
                  <option value="date">Tarih</option>
                  <option value="time">Saat</option>
                </select>
              </div>
              <div class="form-group col-md-9"></div>
              <div class="form-group col-md-3">
                <div class="row">
                  <div class="form-group col-md-6">
                    <b-button
                      variant="danger"
                     @click="SoruDel(Bolumindex,index)"
                    >
                      <i
                        class="bx bx-trash font-size-16 align-middle me-2" 
                      ></i>
                    </b-button>
                  </div>
                  <div
                    class="form-check form-switch form-switch-lg mb-3 col-md-6"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="Form.config.required"
                    />
                    <label class="form-check-label" for="SwitchCheckSizelg"
                      >Gerekli</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>

    <div class="form-group">
      <button @click="SoruAdd(Bolumindex)" type="button" class="btn btn-success">
        Soru Ekle
      </button> 
    </div>
    
    <!-- end col -->

    <hr />
</div>
     <div class="form-group">
    
      <button @click="BolumAdd()" type="button" class="btn btn-success">
        Bölüm Ekle
      </button>
      &nbsp;&nbsp;&nbsp; 
      <button @click="submit" type="button" class="btn btn-primary" v-if="FormJson.length != 0">
        Kaydet
      </button>
    </div> </div>
    <br />
  </Layout>
</template>